export const announcementLabel = {
    titles: {
        table: "공지사항",
        editor: "제목",
    },
    buttons: {
        submit: "완료",
        close: "취소",
    },
}

export const membernewsLabel = {
    titles: {
        table: "게시글 목록",
        editor: "제목",
        write: "작성하기"
    },
    buttons: {
        add: "작성하기",
        close: "닫기",
        submit: "완료",
    },
}
